import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NoBallPopupDetails from './NoBallPopupDetails.vue'

export const NoBallPopup = new PopupBuilder('Is it no ball?')
  .appendBody(NoBallPopupDetails)
  .build()
